import { StyleSheet, Platform, Dimensions } from 'react-native'
import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { getThemeColors } from '../../Themes/Modes'

const styles = StyleSheet.create({
  title: theme => ({
    minWidth: 200,
    color: theme.colors.textColor,
  }),
  subtitle: {
    marginBottom: 24,
  },
  subHeaderContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 24,
    justifyContent: 'space-between',
  },
  confirmButton: {
    marginBottom: 16,
    marginTop: 8,
  },
  modalContentWraper: {
    flexGrow: 1,
    paddingHorizontal: 16,
    paddingVertical: 32,
    marginTop: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  verticalSpacing: {
    marginVertical: 16,
  },
  lottie: {
    width: 150,
    height: 150,
    marginLeft: 0,
  },
  separator: theme => ({
    marginBottom: 16,
    backgroundColor: theme.colors.divider,
  }),
  inputContainer: {
    minHeight: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 70 : 50,
    marginHorizontal: 0,
    marginBottom: 11,
    marginTop: 40,
  },
  inputText: theme => ({
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.textColor,
  }),
  item: {
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 50 : 16,
  },
  itemContent: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  itemTextsWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  noOptionText: (theme) => ({
    marginTop: 30,
    textAlign: 'center',
    color: theme.colors.textColor,
  }),
  icon: {
    width: 28,
    height: 28,
    resizeMode: 'contain',
  },
  disabledStyle: theme => ({
    backgroundColor: getThemeColors(theme.name).disabled,
  }),
  titleStyle: {
    marginLeft: -16,
  },
  closeBtnStyle: {
    marginRight: -16,
  },
  ///Styles for web
  smothPickerHorizontalWrapper: {
    height: 100,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
  },
  smothPickerHorizontalContainer: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    overflow: 'auto'
  },
  OptionWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10,
    marginBottom: 10,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 30,
    paddingRight: 30,
    height: 50,
    borderWidth: 3,
    borderRadius: 10,
    borderColor: 'transparent',
  },
  shareWrapper: {
    paddingHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : '5%',
    paddingVertical: '2%'
  },
  // styles for modal
  modalContainer: {
    height: 0,
  },
  modal: {
    justifyContent: 'flex-end',
    margin: 0,
  },
  main: {
    backgroundColor: Colors.white,
    overflow: 'hidden',
  },
  main_normal: {
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
  },
  main_full: {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    flex: 1,
  },
  content: {
    flexGrow: 1,
  },
})

export default styles
